import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isPlain
} from '../../common/utils';
import { ERR_REP_CUP_INFO, ERR_REQ_CUP_ID } from '../../common/const';

/*
协议Id 
884
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/cupinfo/
说明
实盘获取场的基本信息
*/

const cupInfo = apiRegister('cup-info', {
    protoId: 884,
    path: '/award/reality/cupinfo/',
    cache: 600,  // 默认缓存600秒
    checkQuery(Q) {
        if (!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID // 参数错误
        }
        return 0
    },
    checkResult(R) {
        const {
            cupInfo
        } = R
        if (!isPlain(cupInfo) || !isNumber(cupInfo.cupId)) {
            return ERR_REP_CUP_INFO // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        const {
            nextTradingDay,
            cupInfo
        } = R
        cupInfo.nextTradingDay = nextTradingDay
        return {
            nextTradingDay,
            cupInfo
        }
    }
})

export const cupLoad = cupInfo.send
